import { SET_CREATE_INTENT_RESPONSE } from '../actions/createIntentActions';

const initialState = "check"

const createIntentReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_CREATE_INTENT_RESPONSE:
        return action.payload;
      default:
        return state;
    }
  };
  
  export default createIntentReducer;
  